var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "650px",
        title: "新增数据集",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.dataRule,
            "label-width": "150px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.dataFormSubmit()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "数据集分组", prop: "ruleGroup" } },
            [_vm._v(" " + _vm._s(_vm.dataForm.ruleGroup) + " ")]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "数据集名称", prop: "ruleName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "数据集名称" },
                model: {
                  value: _vm.dataForm.ruleName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "ruleName", $$v)
                  },
                  expression: "dataForm.ruleName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "数据集英文名称", prop: "ruleEnglishName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "数据集英文名称" },
                model: {
                  value: _vm.dataForm.ruleEnglishName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "ruleEnglishName", $$v)
                  },
                  expression: "dataForm.ruleEnglishName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "数据集代码", prop: "ruleCode" } },
            [
              _c("el-input", {
                attrs: { placeholder: "数据集代码" },
                model: {
                  value: _vm.dataForm.ruleCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "ruleCode", $$v)
                  },
                  expression: "dataForm.ruleCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "数据集表名", prop: "tableName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "数据集表名" },
                model: {
                  value: _vm.dataForm.tableName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "tableName", $$v)
                  },
                  expression: "dataForm.tableName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序", prop: "sort" } },
            [
              _c("el-input", {
                attrs: { placeholder: "排序" },
                model: {
                  value: _vm.dataForm.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "sort", $$v)
                  },
                  expression: "dataForm.sort",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.dataFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }